import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppService {
  private readonly _isMobileView$ = new ReplaySubject<{ state: boolean }>(1);
  private readonly _mobileViewBreakPoint = 1023;

  constructor() {
    this._isMobileView$.next(this.isMobileView());

    window.addEventListener('resize', () => {
      this._isMobileView$.next(this.isMobileView());
    });
  }

  public get isMobileView$(): Observable<{ state: boolean }> {
    return this._isMobileView$.asObservable().pipe(distinctUntilChanged());
  }

  private isMobileView(): { state: boolean } {
    return { state: document.documentElement.clientWidth <= this._mobileViewBreakPoint };
  }
}
